export const Fonts = {
  H1: {
    fontWeight: 700,
    fontStyle: "normal",

    lineHeight: "3.501rem",
    letterSpacing: undefined,
  },
  H2: {
    fontWeight: 300,
    fontStyle: "normal",
    fontSize: "3.75rem",
    lineHeight: "3.501rem",
    letterSpacing: undefined,
  },
  H3: {
    fontWeight: 700,
    fontStyle: "normal",
    // fontSize: "3rem",
    lineHeight: "21px",
    letterSpacing: undefined,
  },
  H4: {
    fontWeight: 300,
    fontStyle: "normal",
    fontSize: "2.25rem",
    lineHeight: "3.501rem",
    letterSpacing: undefined,
  },
  H5: {
    fontWeight: 300,
    fontStyle: "normal",
    fontSize: "1.5rem",
    lineHeight: "3.501rem",
    letterSpacing: undefined,
  },
  H6: {
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: 20,
    lineHeight: "32px",
    letterSpacing: undefined,
  },
  SubTitle1: {
    fontWeight: 400,
    fontStyle: "normal",
    fontsize: "1.125rem",
    lineHeight: "1.609rem",
    letterSpacing: undefined,
  },
  SubTitle2: {
    fontWeight: 600,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "1.374rem",
    letterSpacing: undefined,
  },
  Body1: {
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "1rem",
    lineHeight: "1.5rem",
    letterSpacing: undefined,
  },
  Body2: {
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "0.875rem",
    lineHeight: "1.251rem",
    letterSpacing: undefined,
  },
  Body3: {
    fontWeight: 300,
    fontStyle: "normal",
    fontSize: "0.625rem",
    lineHeight: "1rem",
    letterSpacing: undefined,
  },
  Caption1: {
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "0.75rem",
    lineHeight: "1.245rem",
    letterSpacing: undefined,
  },
  Caption2: {
    fontWeight: 300,
    fontStyle: "normal",
    fontSize: "0.625rem",
    lineHeight: "1rem",
    letterSpacing: undefined,
  },
  Content1: {
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "23px",
    letter: "0.4px",
    letterSpacing: undefined,
  },
  mbaContent: {
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "23.24px",
    letter: "0.4px",
    align: "justified",
    letterSpacing: undefined,
  },

  SubEnglish: {
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "0.625rem",
    lineHeight: "1.038rem",
    letterSpacing: undefined,
  },
  Logo: {
    fontWeight: 700,
    fontStyle: "normal",
    fontSize: "1.625rem",
    lineHeight: "2.324rem",
    letterSpacing: undefined,
  },
  Button1: {
    fontWeight: 700,
    fontStyle: "normal",
    fontSize: "0.938rem",
    lineHeight: "1.625rem",
    letterSpacing: undefined,
  },
  MainSubContent: {
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: 18,
    lineHeight: "26px",
    letter: "0.52px",
    letterSpacing: undefined,
  },
  Name: {
    fontWeight: 700,
    fontStyle: "normal",
    fontSize: 14,
    lineHeight: "22px",
    letter: "0.1px",
    letterSpacing: undefined,
  },
  NameContent: {
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: 12,
    lineHeight: "15px",
    letter: "0.1px",
    letterSpacing: undefined,
  },
  ContentHeader: {
    fontWeight: 700,
    fontStyle: "normal",
    fontSize: 18,
    lineHeight: "29.88px",
    letter: "0.4px",
    letterSpacing: undefined,
  },
  ContentHeader2: {
    fontWeight: 700,
    fontStyle: "normal",
    fontSize: 15,
    lineHeight: "26px",
    letter: "0.46px",
    letterSpacing: undefined,
  },
  ContentHeader3: {
    fontWeight: 700,
    fontStyle: "normal",
    fontSize: 24,
    lineHeight: "29.88px",
    letter: "0.4px",
    letterSpacing: undefined,
  },
  ModuleText: {
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: 14,
    lineHeight: "14px",
    letter: "0.4px",
    letterSpacing: undefined,
  },
  SimModuleText: {
    fontWeight: 700,
    fontStyle: "normal",
    fontSize: 12,
    lineHeight: "18px",
    letter: "0.4px",
    letterSpacing: undefined,
  },
  mSimModuleText: {
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: 16,
    lineHeight: 1.5,
    letter: "0.4px",
    letterSpacing: undefined,
  },
  SimModuleSubText: {
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: 11,
    lineHeight: "18px",
    letter: "0.4px",
    letterSpacing: undefined,
  },
  SimModuleMentalSubText: {
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: 16,
    lineHeight: "18px",
    letter: "0.4px",
    letterSpacing: undefined,
  },
  mSimModuleText2: {
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: 14,
    lineHeight: 1.5,
    letter: "0.4px",
    letterSpacing: undefined,
  },
  elderContent: {
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "22.5px",
    letter: "0.4px",
    letterSpacing: undefined,
  },
  elderNews: {
    fontWeight: 700,
    fontStyle: "normal",
    fontSize: "16px",
    lineHeight: "25.7px",
    letter: "0.4px",
  },
  teamSubTitle: {
    fontWeight: 700,
    fontStyle: "normal",
    lineHeight: "25px",
  },
  researchTitle: {
    fontWeight: 700,
    fontStyle: "normal",
    lineHeight: "70px",
  },
};
